// "Download certificate" — generates the PDF in the browser, so there's no
// request to wait on. Always-visible button (never hover-revealed).

import { useState } from "react";
import { Award, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { downloadDriveCertificate, downloadTreeCertificate } from "@/lib/certificate";

export default function CertificateButton({ kind, data, className = "", variant = "primary" }) {
    const [busy, setBusy] = useState(false);

    const run = async () => {
        setBusy(true);
        try {
            if (kind === "tree") await downloadTreeCertificate(data);
            else await downloadDriveCertificate(data);
        } catch {
            toast.error("Could not generate the certificate. Please try again.");
        } finally {
            setBusy(false);
        }
    };

    const styles =
        variant === "primary"
            ? "btn-primary text-white"
            : "border border-seedh-border text-seedh-blue hover:bg-seedh-surface-blue";

    return (
        <button
            type="button"
            onClick={run}
            disabled={busy}
            className={`rounded-full px-5 py-2.5 text-sm font-semibold inline-flex items-center justify-center gap-2 transition-colors disabled:opacity-60 ${styles} ${className}`}
        >
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Award className="w-4 h-4" />}
            Download certificate
        </button>
    );
}
